module.exports = __webpack_public_path__ + "static/12x12-nephrite-jade-tile-natural-c9e65d8d12b3eab3bfbbfc6edfed06f6.jpg";